import { toast } from "react-toastify";
import { GetAllWorkOrdersApi } from "../../../Api/Operations/WorkOrders";

/**
 * Work Orders Redux Actions
 * Pattern: Action creator + Async thunk with error handling
 */

// Synchronous Action Creator
export const GetAllWorkOrders = (data) => {
  return {
    type: "get_all_work_orders",
    payload: data,
    loader: false,
  };
};

// Async Thunk - Fetch all work orders
export function getallWorkOrders(projectId) {
  return async (dispatch) => {
    try {
      const result = await GetAllWorkOrdersApi(projectId);

      if (result.data?.IsSuccess === true) {
        dispatch(GetAllWorkOrders(result.data.Data));
      } else {
        toast.error(result.data?.Message || "Failed to fetch work orders");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching work orders!");
    }
  };
}
